import BrandLoader from "./BrandLoader";

/** Lightweight fallback for lazy route transitions */
export default function Loader() {
  return <BrandLoader variant="route" />;
}
